// app/scripts/utils/logger.js 

// Default browser-safe logger (can be enhanced)
let loggerImplementation = {
    info: (...args) => console.info('[INFO]', ...args),
    warn: (...args) => console.warn('[WARN]', ...args),
    error: (...args) => console.error('[ERROR]', ...args),
    debug: (...args) => {
      // In a Webpack setup, process.env.NODE_ENV is typically available.
      // For other custom env vars in the browser, you might need Webpack's DefinePlugin.
      if (process.env.NODE_ENV !== 'production' || process.env.APP_DEBUG_LOGS === 'true') {
        console.debug('[DEBUG]', ...args);
      }
    },
  };
  
  // Export the logger functions using module.exports
  module.exports = {
    info: (...args) => loggerImplementation.info(...args),
    warn: (...args) => loggerImplementation.warn(...args),
    error: (...args) => loggerImplementation.error(...args),
    debug: (...args) => loggerImplementation.debug(...args),
  };